import React from 'react';
import { Divider, Card, Grid } from 'semantic-ui-react';
import Content from './Content';
import { Link, withRouter } from 'react-router-dom';
import { compose, withApollo, graphql } from 'react-apollo'
import PaginationWrapper from './PaginationWrapper'
import queryString from 'query-string'
import TicketFilters from './TicketFilters';
import moment from "moment";
import mapConnection from '../utils/connectionMapper'
import { paginationVariables, withPagination } from '../utils/pagination'
import { PassengerTicketsConnection } from '../queries/PassengerTicketsConnection'
import PathView from './PathView'
import { ScrollableGrid } from './styles/ScrollableGrid'
import { saveTicketsFilters, clearTicketsFilters } from '../actions/filters-actions'
import { connect } from 'react-redux'

const initialFilters = {
  airlineNames: [],
  flightNumbers: [],
  affiliateNames: [],
  claim: undefined,
  ticketForm: undefined,
  unclaimable: 'false',
  firstAndLastName: [],
  passengerEmails: []
}

const mapDispatchToProps = dispatch => {
  return {
    saveTicketsFilters: filters => { dispatch(saveTicketsFilters(filters)) },
    clearTicketsFilters: () => { dispatch(clearTicketsFilters()) }
  }
}

const initialOrder = 'asc'

const MenuItems = (props) => <TicketFilters {...props} />

class Tickets extends React.Component {
  state = {};

  componentWillMount = () => {
    const { claim, ticketForm, unclaimable } = this.props.PassengerTicketsConnection.variables.filter
    const filters = {
      ...initialFilters,
      ...this.props.PassengerTicketsConnection.variables.filter,
      claim: claim !== undefined ? String(claim) : undefined,
      ticketForm: ticketForm !== undefined ? String(ticketForm) : undefined,
      unclaimable: unclaimable !== undefined ? String(unclaimable) : undefined,
    }
    const orderBy = this.props.PassengerTicketsConnection.variables.orderBy[1] || initialOrder;
    
    this.setState({ filters, orderBy })
  }

  handleDateFilterChange = (date) => {
    const filters = {
      ...this.state.filters,
      departureDate: date ? moment(date).format('YYYY-MM-DDTHH:mm') : undefined
    }
    this.setState({ filters })
  }
  handleBooleanFilterChange = (filter, e, { value }) => {
    const { filters } = this.state;
    filters[filter] = value;
    this.setState({ filters: { ...filters } })
  }

  handleFilterAdd = (filter, e, { value }) => {
    const isFilterPresent = this.state.filters[filter].includes(value)
    if (!isFilterPresent) {
      const filterValue = [...this.state.filters[filter], value]
      const filters = {
        ...this.state.filters,
        [filter]: filterValue
      }
      this.setState({ filters })
    }
  }

  handleOrderChange = (e, {checked}) => {
    this.setState({ orderBy: checked ? 'desc' : 'asc' })
  }

  handleFiltersApply = () => {
    const filters = {
      ...this.state.filters
    }
    const query = queryString.stringify({ ...filters, orderBy: this.state.orderBy }, { arrayFormat: 'bracket' })

    this.props.saveTicketsFilters(query)
    this.props.history.replace({ ...this.props.history.location, search: query })
  }

  handleFilterDelete = (value, filter) => {
    const indexToDelete = this.state.filters[filter].indexOf(value)
    let filterValue = [...this.state.filters[filter]]
    filterValue.splice(indexToDelete, 1)
    const filters = {
      ...this.state.filters,
      [filter]: filterValue
    }
    this.setState({ filters })
  }

  handleClearFilters = () => {
    this.setState({filters: initialFilters})
    this.props.clearTicketsFilters()
    this.props.history.push('/tickets')    
  }

  render = () => {
    const passengerTicketsConnection = this.props.PassengerTicketsConnection.passengerTicketsConnection
      && mapConnection(this.props.PassengerTicketsConnection.passengerTicketsConnection).map(ticket => ({
        ...ticket,
        flightNumbers: mapConnection(ticket.flightsPassengerTicketsConnection).map(({flight}) => flight.flightNumber)
      }))
  const { pageInfo, totalCount } = this.props.PassengerTicketsConnection.passengerTicketsConnection ? this.props.PassengerTicketsConnection.passengerTicketsConnection : {}
    const grid = {
      minWidth: '900px',
      ticketWidth: 2,
      pnrWidth: 2,
      paxWidth: 3,
      dateWidth: 2,
      airlineWidth: 2,
      affiliateWidth: 3,
      flightsWidth: 2
    }

    return (
      <Content
        MenuItems={MenuItems}
        loading={this.props.PassengerTicketsConnection.loading}
        onApply={this.handleFiltersApply}
        menuProps={{
          onDateFilterChange: this.handleDateFilterChange,
          filters: this.state.filters,
          orderBy: this.state.orderBy,
          onFilterAdd: this.handleFilterAdd,
          onFilterDelete: this.handleFilterDelete,
          onBooleanFilterChange: this.handleBooleanFilterChange,
          onOrderChange: this.handleOrderChange,
          onClear: this.handleClearFilters
        }}
      >
      <PathView paths={[
        {name: 'Tickets'}
      ]}/>
      <Divider hidden/>
      <div style={ScrollableGrid}>
        <Grid padded style={{minWidth:grid.minWidth}}>
          <Grid.Row style={{minWidth:grid.minWidth}}>
            <Grid.Column width={grid.ticketWidth}>
              <Card.Meta>Ticket number</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.pnrWidth}>
              <Card.Meta>PNR</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.paxWidth}>
              <Card.Meta>PAX name</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.dateWidth}>
              <Card.Meta>Departure date</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.airlineWidth}>
              <Card.Meta>Airline</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.affiliateWidth}>
              <Card.Meta>Affiliate</Card.Meta>
            </Grid.Column>
            <Grid.Column width={grid.flightsWidth}>
              <Card.Meta>Flights</Card.Meta>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {passengerTicketsConnection && passengerTicketsConnection.map((el, index) => (
          <Link key={index} to={"/ticket/" + el.id}>
            <Card fluid style={{minWidth:grid.minWidth}}>
              <Card.Content>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={grid.ticketWidth}>
                      <Card.Header>
                        {el.number}
                      </Card.Header>
                    </Grid.Column>
                    <Grid.Column width={grid.pnrWidth}>
                      <Card.Meta>
                        {el.pnr}
                      </Card.Meta>
                    </Grid.Column>
                    <Grid.Column width={grid.paxWidth}>
                      <Card.Meta>
                        {el.passengerLastName + " " + el.passengerFirstName}
                      </Card.Meta>
                    </Grid.Column>
                    <Grid.Column width={grid.dateWidth}>
                      <Card.Meta>
                        {el.departureDate}
                      </Card.Meta>
                    </Grid.Column>
                    <Grid.Column width={grid.airlineWidth}>
                      <Card.Meta>
                        {el.airlineNames}
                      </Card.Meta>
                    </Grid.Column>
                    <Grid.Column width={grid.affiliateWidth}>
                      <Card.Meta>
                        {el.affiliate && el.affiliate.name}
                      </Card.Meta>
                    </Grid.Column>
                    <Grid.Column width={grid.flightsWidth}>
                      <Card.Meta>
                        {el.flightNumbers && el.flightNumbers.join(', ')}
                      </Card.Meta>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card>
          </Link>
        ))}
      </div>
      <Divider hidden/>
        <PaginationWrapper {...pageInfo} totalCount={totalCount}/>
    </Content>
    )
  }
}

const TicketsWithData = compose(
  withPagination(initialFilters, initialOrder),
  withApollo,
  withRouter,
  graphql(PassengerTicketsConnection, {
    name: 'PassengerTicketsConnection',
    options: ({ filter, orderBy, ...rest }) => {
      const filters = {
        ...filter,
        claim: filter.claim ? filter.claim === 'true' : undefined,
        ticketForm: filter.ticketForm ? filter.ticketForm === 'true' : undefined,
        unclaimable: filter.unclaimable ? filter.unclaimable === 'true' : 'false',
        firstAndLastName: filter.firstAndLastName ? filter.firstAndLastName : undefined
      }
      return {
        variables: {
          orderBy: [['created_at', orderBy]],
          filter: filters,
          ...paginationVariables(rest)
        },
        notifyOnNetworkStatusChange: true
      }
    }
  }),
  connect(null, mapDispatchToProps)
)(Tickets)

export default TicketsWithData



// WEBPACK FOOTER //
// ./src/component/Tickets.js